
import { BaseModulePublicApi } from "../../base/BaseModulePublicApi";

export class PublicPointOfInterestApi extends BaseModulePublicApi {
  basePath = 'points_of_interest';
};
